import styled from '@emotion/styled';
import { Modal, theme } from '@ublend-npm/aulaui-next';

type LoaderContainerProps = Readonly<{
  centerOffset: string;
}>;

export const LoaderContainer = styled.div<LoaderContainerProps>`
  position: absolute;
  top: ${({ centerOffset }) => `calc(50% - ${centerOffset})`};
  left: ${({ centerOffset }) => `calc(50% - ${centerOffset})`};
  z-index: 0;
`;

export const ContentContainer = styled.div`
  position: relative;
  height: 100%;
  overflow: hidden;
`;

export const ContentHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing.medium};
`;

export const ContentHeader = styled.h2`
  margin: 0;
  font-weight: ${theme.font.weight.medium};
`;

export const StyledModal = styled(Modal)`
  div[class*='itemDefault-Modal'] {
    padding: ${theme.spacing.xLarge};
    border-radius: 16px;
    height: 80%;
    min-width: 80%;
  }
`;

export const IFrame = styled('iframe')`
  z-index: 1;
  position: relative;
  border: none;
  width: 100%;
  height: calc(100% - 48px);
`;
